export const getCdnUrl = (iataCode, path) => path ? `https://cdn.websky.aero/content/frontend/images/${iataCode}/${path}` : '';
export const getContentUrl = (iataCode, path) => path ? `https://cdn.websky.aero/content/${iataCode}/images/${path}` : '';
export const isSvgUrl = (url) => {
    try {
        const { pathname } = new URL(url, window.location.href);
        return pathname.toLowerCase().endsWith('.svg');
    }
    catch (_a) {
        return url.toLowerCase().endsWith('.svg');
    }
};
